<div class="relative">
    <div class="md:p-4">
        <div class="flex flex-col gap-4">
            <dl
                [ngStyle]="textStyles"
                class="divide-y"
                [ngClass]="{
                'divide-gray-100': job?.darkMode,
                'divide-gray-300': !job?.darkMode,
            }">
                <div *ngIf="img" class="flex pl-4 md:pl-0 md:justify-center mb-2">
                    <advanced-image alt="Logo" [cldImg]="img" [plugins]="plugins"></advanced-image>
                </div>
                <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" *ngIf="component?.showTitle !== false">
                    <dt class="text-sm font-bold leading-6" i18n>Job Title</dt>
                    <dd
                        class="mt-1 text-sm leading-6 sm:col-span-2 sm:mt-0"
                        [ngClass]="{
                            'text-gray-700': !job?.darkMode,
                            'text-gray-100': job?.darkMode
                        }">
                        {{ job?.title }}
                    </dd>
                </div>
                <div
                    class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0"
                    *ngIf="component?.showCategory !== false && job?.category">
                    <dt class="text-sm font-bold leading-6" i18n>Category</dt>
                    <dd
                        class="mt-1 text-sm leading-6 sm:col-span-2 sm:mt-0"
                        [ngClass]="{
                            'text-gray-700': !job?.darkMode,
                            'text-gray-100': job?.darkMode
                        }">
                        {{ job?.category | titlecase }}
                    </dd>
                </div>

                <div
                    class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0"
                    *ngIf="component?.showLocation !== false">
                    <dt class="text-sm font-bold leading-6" i18n>Location</dt>
                    <dd
                        class="mt-1 text-sm leading-6 sm:col-span-2 sm:mt-0"
                        [ngClass]="{
                            'text-gray-700': !job?.darkMode,
                            'text-gray-100': job?.darkMode
                        }">
                        {{ locationString }}
                    </dd>
                </div>

                <div
                    class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0"
                    *ngIf="component?.showPostedDate !== false">
                    <dt class="text-sm font-bold leading-6" i18n>Posted On</dt>
                    <dd
                        class="mt-1 text-sm leading-6 sm:col-span-2 sm:mt-0"
                        [ngClass]="{
                            'text-gray-700': !job?.darkMode,
                            'text-gray-100': job?.darkMode
                        }">
                        {{ job?.thirdPartyJob?.createdAt || job?.createdAt | date : "MMMM d, yyyy" }}
                    </dd>
                </div>

                <div
                    class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0"
                    *ngIf="component?.showJobType !== false && job?.type">
                    <dt class="text-sm font-bold leading-6" i18n>Job Type</dt>
                    <dd
                        class="mt-1 text-sm leading-6 sm:col-span-2 sm:mt-0"
                        [ngClass]="{
                            'text-gray-700': !job?.darkMode,
                            'text-gray-100': job?.darkMode
                        }">
                        {{ job?.type }}
                    </dd>
                </div>

                <div
                    class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0"
                    *ngIf="job?.reference && component?.showJobReference !== false">
                    <dt class="text-sm font-bold leading-6" i18n>Job Reference</dt>
                    <dd
                        class="mt-1 text-sm leading-6 sm:col-span-2 sm:mt-0"
                        [ngClass]="{
                            'text-gray-700': !job?.darkMode,
                            'text-gray-100': job?.darkMode
                        }">
                        {{ job?.reference }}
                    </dd>
                </div>

                <div
                    class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0"
                    *ngIf="job?.salary?.from && job?.salary?.to && component?.showSalary !== false">
                    <dt class="text-sm font-bold leading-6" i18n>Salary</dt>
                    <dd
                        class="mt-1 text-sm leading-6 sm:col-span-2 sm:mt-0"
                        [ngClass]="{
                            'text-gray-700': !job?.darkMode,
                            'text-gray-100': job?.darkMode
                        }">
                        {{ salaryString }}
                    </dd>
                </div>
            </dl>
            <app-apply-button
                [component]="component"
                [buttonConfig]="component.applyButton"
                [job]="job"></app-apply-button>
            <app-refer-button
                [component]="component"
                [buttonConfig]="component.referButton"
                [job]="job"></app-refer-button>
        </div>
    </div>
</div>
